<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IhxWiq/tc-custom/9781497694989.jpg?1724154588987" alt="This image is the cover for the book Freddy the Pied Piper, Freddy the Pig"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Freddy the Pied Piper, Freddy the Pig
      </h1>
      <p class="bookDescription body article font2">
        <p>When the circus falls on hard times, Freddy concocts a plan to raise money by driving out the mice in a nearby village. However, he must also contend with angry farm mice, kidnapping, and a dangerous trek to Virginia. After all his hard work, Mr. Broomschmidt, the circus owner, refuses to accept any charity, and Freddy must find some other way to save his beloved circus. In <i>Freddy the Pied Piper</i>, Walter Brooks has told yet another rollicking, humorous adventure tale with wonderful illustrations by the inimitable Kurt Wiese.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter R. Brooks, Kurt Wiese
      </h2>
      
      <p class="authorDescription body article">Walter R. Brooks (1886-1958) is the beloved author of 26 books about Freddy the Pig. He edited for magazines, including <I>The New Yorker</I>. In addition to the Freddy books, Brooks created the character Mr. Ed the Talking Horse.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5adc8e6